import React, {Component} from 'react';
import './EtaMap.css';
import MapboxMap from './MapboxMap';

const mapStyle = 'light_color';

const mapboxMapComponent = new MapboxMap();

class EtaMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mapboxMap: null,
            destinationMarkerSet: false,
            setEtaEvents: false,
            mapHasLoaded: false,
            popupMarker: null,
            etaMarker: null,
            user: null,
            focusOnUser: true
        };

        this.setDestinationMarker = this.setDestinationMarker.bind(this);
        this.toggleFocus = this.toggleFocus.bind(this);
        this.setUserMarker = this.setUserMarker.bind(this);
    }

    componentDidMount() {
        let map;

        switch (this.props.status.etaStatus) {
            case 'driving':
                map = mapboxMapComponent.createMap(mapStyle);
                this.setDestinationMarker(map, false, this.props.status.destinationLat, this.props.status.destinationLng);
                this.createInitialMarker(map, this.props.status.lng, this.props.status.lat, 'driving');
                this.setUserMarker(map);
                break;
            case 'aborted':
                map = mapboxMapComponent.createMap(mapStyle);
                this.setDestinationMarker(map, false, this.props.status.destinationLat, this.props.status.destinationLng);
                this.createInitialMarker(map, this.props.status.lng, this.props.status.lat, 'stopped');
                this.setUserMarker(map);
                break;
            case 'closed':
                map = mapboxMapComponent.createMap(mapStyle);
                this.setDestinationMarker(map, false, this.props.status.destinationLat, this.props.status.destinationLng);
                this.createInitialMarker(map, this.props.status.lng, this.props.status.lat, 'stopped');
                this.setUserMarker(map);
                break;
            case 'arrived':
                map = mapboxMapComponent.createMap(mapStyle);
                this.setDestinationMarker(map, true, this.props.status.destinationLat, this.props.status.destinationLng);
                break;
            case 'id-error':
                map = mapboxMapComponent.createMap(mapStyle);
                break;
            default:
                break;
        }

        this.registerMapEvents(map);

        this.setState({
            mapboxMap: map
        });
    }

    setDestinationMarker(map, focusOnDestination, lat, lng) {
        const el = document.createElement('div');
        el.className = 'marker';

        mapboxMapComponent.addMarker(map, null, 'marker', lng, lat, null);

        if (focusOnDestination) {
            mapboxMapComponent.flyTo(map, lat, lng, 10);
        }
    }

    setUserMarker(map) {
        const user = mapboxMapComponent.addMarker(map, null, 'user-location', this.props.status.lng, this.props.status.lat, null);
        this.setState({
            user: user,
        });
    }

    createInitialMarker(map, lng, lat, type) {
        let marker;
        if (type === 'driving') {
            const html = `<h1>ETA</h1><p class='popup-subtitle'>Loading...</p>`;
            marker = mapboxMapComponent.addMarker(map, html, 'eta-popup', 0, 0, null, { anchor: 'bottom', offset: [0, -68] });

        } else if (type === 'stopped') {
            const html = `<h1 style='color: red; font-weight: 500'>Gestopt met delen</h1><p class='popup-subtitle'></p>`;
            marker = mapboxMapComponent.addMarker(map, html, 'eta-popup', lng, lat, null, { anchor: 'bottom', offset: [0, -68] });
            mapboxMapComponent.flyTo(map, lat, lng, 10);
        }

        this.setState({
            popupMarker: marker
        });
    }

    componentWillReceiveProps() {
        const map = this.state.mapboxMap;
        const popupMarker = this.state.popupMarker;
        const eta = this.props.eta;
        const status = this.props.status.etaStatus;

        // if client is receiving ETA from socket, (status === driving)
        if (this.state.mapboxMap !== null && eta !== null) {
            this.setState({
                eta: {
                    lng: eta.lng,
                    lat: eta.lat
                }
            });

            if (this.state.focusOnUser) {
                mapboxMapComponent.flyTo(map, eta.lat, eta.lng);
            }

            // only fire eta once
            if (this.state.setEtaEvents === false) {
                map.fire('eta');
            } else {
                map.fire('etaUpdates');
            }
        }


        // if state is not driving, but has been driving before
        if (this.props.status.etaStatus !== 'driving' && popupMarker !== null && this.props.statusHasBeenDriving) {
            this.setState({
                setEtaEvents: false,
            });

            const html = `<h1 style='color: red; font-weight: 500'>Gestopt met delen</h1><p class='popup-subtitle'></p>`;
            mapboxMapComponent.setMarkerHTML(popupMarker, html);
            mapboxMapComponent.flyTo(map, this.state.eta.lat, this.state.eta.lng);

            if (this.state.user !== null && status === 'arrived') {
                mapboxMapComponent.setMarkerClass(this.state.user, 'hidden');
                if (popupMarker !== null) {
                    popupMarker.getElement().className = 'hidden';
                }
            }

            if (popupMarker !== null && status !== 'arrived') {
                popupMarker.setLngLat([this.state.eta.lng, this.state.eta.lat]).addTo(map);
                popupMarker.getElement().className = 'eta-popup maplibregl-marker';
            } else if (status !== 'arrived') {
                this.createInitialMarker(map, eta.lng, eta.lat, 'closed');
            }
        }

    }

    registerMapEvents(map) {
        map.on('eta', function () {
            mapboxMapComponent.flyTo(map, this.props.eta.lat, this.props.eta.lng, 10);
            this.setState({
                setEtaEvents: true
            });
        }.bind(this));

        map.on('etaUpdates', function () {
            if (this.state.user !== null && this.state.popupMarker !== null) {
                mapboxMapComponent.setMarkerLocation(this.state.user, this.props.eta.lng, this.props.eta.lat);

                const popupMarker = this.state.popupMarker;
                const date = new Date(this.props.eta.eta);
                let html;
                if (this.props.eta.currentSpeed < 0) {
                    html = `<h1 style="color: ${this.props.themeColor}">ETA</h1><h1 style="color: ${this.props.themeColor}">${(date.getHours()<10?'0':'') + date.getHours()}:${(date.getMinutes()<10?'0':'') + date.getMinutes()}</h1></div>`;
                } else {
                    html = `<h1 style="color: ${this.props.themeColor}">${(date.getHours()<10?'0':'') + date.getHours()}:${(date.getMinutes()<10?'0':'') + date.getMinutes()}</h1><p class="eta-popup-speed popup-subtitle">${this.props.eta.currentSpeed} km/u</p></div>`;
                }
                mapboxMapComponent.setMarkerLocation(popupMarker, this.props.eta.lng, this.props.eta.lat);
                mapboxMapComponent.setMarkerHTML(popupMarker, html);
            }
        }.bind(this));

        map.on('drag', function () {
            this.setState({
                focusOnUser: false
            })
        }.bind(this));

        map.on('load', function () {
            this.props.showContent();
        }.bind(this));
    }

    toggleFocus() {
        this.setState({
            focusOnUser: !this.state.focusOnUser
        });
    }


    render() {
        let focusOnUserButton;
        if (this.props.status.etaStatus === 'driving') {
            focusOnUserButton = <div className='map-controls-wrapper'>
                <div className='map-control-button'>
                    <button style={{backgroundColor: this.state.focusOnUser ? this.props.themeColor : ''}} onClick={this.toggleFocus} className={this.state.focusOnUser ? 'focus-on-user' : ''}>
                        Volgen
                    </button>
                </div>
            </div>;

            if (this.state.mapboxMap !== null && this.props.eta === null) {
                if (this.state.focusOnUser) {
                    mapboxMapComponent.flyTo(this.state.mapboxMap, this.props.status.lat, this.props.status.lng);
                }
            }
        }
        return (
            <div className={this.props.landscape ? 'EtaMap EtaMapLandscape' : 'EtaMap'}>
                <div id='map'>
                    {focusOnUserButton}
                </div>
            </div>
        );
    }
}

export default EtaMap;
